/**
 * Documentation Premium — FACETIFUL
 * Animation au scroll (IntersectionObserver), sans dépendance externe.
 */
(function () {
  'use strict';

  function initDocPremium(section) {
    var targets = section.querySelectorAll('[data-doc-reveal]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback : pas d'observer disponible, on affiche directement
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  function initAll() {
    document.querySelectorAll('[data-doc-premium]').forEach(initDocPremium);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Compatibilité éditeur de thème Shopify (aperçu live des sections)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-doc-premium]');
    if (section) initDocPremium(section);
  });
})();
